import {
    SEARCH_CATEGORY_RESULT_FETCH_DATA_SUCCESS,
    SEARCH_CATEGORY_RESULT_HAVE_ERROR,
    SEARCH_CATEGORY_RESULT_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of search modal category result actions
export function searchModalCategoryResultAction(action, payload) {
    switch (action) {
        case SEARCH_CATEGORY_RESULT_HAVE_ERROR:
            return {
                type: action,
                hasError: payload,
            };

        case SEARCH_CATEGORY_RESULT_ARE_LOADING:
            return {
                type: action,
                isLoading: payload,
            };

        case SEARCH_CATEGORY_RESULT_FETCH_DATA_SUCCESS:
            return {
                type: action,
                searchModalCategoryResult: payload,
            };

        default:
            return;
    }
}

// Async action creator function to fetch search modal category result data
export function searchModalCategoryResultFetchData() {
    return (dispatch) => {
        try {
            // Dispatch action indicating data is loading
            dispatch(searchModalCategoryResultAction(SEARCH_CATEGORY_RESULT_ARE_LOADING, true));

            // Check if home primary data is available in local storage
            if (localStorage.getItem("SearchCategoryResult")) {
                // If available, dispatch action with data from local storage
                dispatch(
                    searchModalCategoryResultAction(
                        SEARCH_CATEGORY_RESULT_FETCH_DATA_SUCCESS,
                        JSON.parse(localStorage.getItem("SearchCategoryResult")),
                    ),
                );
            }

            // Fetch search modal category result data using GET request
            return new Promise((resolve, reject) => {
                Get(HttpService.SearchCategoryResult).then(
                    (result) => {
                        // Store fetched data in local storage
                        localStorage.setItem("SearchCategoryResult", JSON.stringify(result.data));
                        // Dispatch action with fetched search modal category result data
                        dispatch(searchModalCategoryResultAction(SEARCH_CATEGORY_RESULT_FETCH_DATA_SUCCESS, result.data));
                        resolve(result);
                    },
                    (error) => {
                        reject(error); // Reject promise with error if fetching fails
                    },
                );
            });
        } catch (error) {
            // Dispatch action if there's an error in fetching data
            dispatch(searchModalCategoryResultAction(SEARCH_CATEGORY_RESULT_HAVE_ERROR, true));
        }
    };
}
